
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[lang]/instant-espresso",
      function () {
        return require("private-next-pages/[region]/[lang]/instant-espresso.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[lang]/instant-espresso"])
      });
    }
  